import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppState } from '../../store/app/app.state';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuardService implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const isInMaintenance = this.store.selectSnapshot(AppState.isInMaintenance);
    const currentRouteIsMaintenance = route.url.length > 0 && route.url[0].path === 'maintenance';

    if (currentRouteIsMaintenance && !isInMaintenance) {
      this.router.navigate(['/']);
    } else if (!currentRouteIsMaintenance && isInMaintenance) {
      this.router.navigate(['/maintenance']);
    }

    return true;
  }
}
